import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CpSignatureComponent } from './cp-signature/cp-signature.component';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

@NgModule({
  declarations: [
    CpSignatureComponent,
  ],
  exports: [
    CpSignatureComponent,
  ],
  imports: [
    CommonModule,
    FontAwesomeModule,
  ],
})
export class SignatureModule {
}
